module.exports = __webpack_public_path__ + "img/menu_bottom_8.fbcfe44b.svg";